import React, { useEffect } from 'react';

import { createRules, FormFields } from '@epi-forms/helpers';
import { maxLength, hasPendingLoad } from '@epi-helpers/formHelpers/validators';
import { ITerminationDate } from '@epi-models/pages/Beneficiaries';
import { useModal } from '@epi-shared/hooks';
import { Box, Button, ButtonMode, CalendarIcon } from 'edenred-ui';
import { useFormContext, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TerminationDateDialog } from './components/TerminationDateDialog';
import { StyledTextField } from './TerminationDate.styles';

export const TerminationDate = ({
  showTerminationButton = true,
  isAddMode
}: ITerminationDate) => {
  const { t } = useTranslation();
  const { isModalOpen, openModal, closeModal } = useModal();
  const { control, watch, trigger } = useFormContext();
  const pendingLoadDate = watch(FormFields.PendingLoadDate);
  const {
    field: { value: EoB },
    fieldState: { error }
  } = useController({
    name: FormFields.EndOfBenefit,
    control,
    rules: createRules([maxLength(20), hasPendingLoad(pendingLoadDate)])
  });

  useEffect(() => {
    trigger(FormFields.EndOfBenefit);
  }, [EoB]);

  return (
    <Box>
      {showTerminationButton && (
        <StyledTextField
          label={t('containers.beneficiaries.detail.termination_modal_title')}
          value={EoB}
          readOnly
          required
          error={!!error}
          helperText={error?.message}
          InputProps={{
            endAdornment: (
              <Button
                id="containers.beneficiaries.detail.end_of_benefit"
                mode={ButtonMode.Link}
                onClick={openModal}
                type="button"
              >
                <CalendarIcon />
              </Button>
            )
          }}
        />
      )}
      <TerminationDateDialog
        isOpen={isModalOpen}
        handleClose={closeModal}
        isAddMode={isAddMode}
      />
    </Box>
  );
};
